import ProviderTerminationService from "@app/provider-terminations/providerTerminationService";
import BulkProviderChangeReports from "../shared/BulkProviderChangeReports";
import { JSX } from "react";

const providerTerminationService = new ProviderTerminationService();
const ViewMyTerminations = (): JSX.Element => {
  const endpoint = () => providerTerminationService.getBulkProviderTerminationExports();
  return <BulkProviderChangeReports endpoint={endpoint} title="Volume Termination" buttonTerm="Terminations" />;
};

export default ViewMyTerminations;
